<div
  [ngClass]="this.currentUser.role.name == 'customer' || this.currentUser.role.name == 'client' ? 'card card-widget widget-user card-dark' : 'card card-widget widget-user'">
  <div class="widget-user-header bg-info-active">
    <div class="edit-container">
      <div class="dropdown" *ngIf="user.role.name === 'user'">
        <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" style="cursor: pointer;" (click)="navigateToUser(user.id)"
            translate>settings.profile</a>
          <a *ngIf="this.currentUser.role.name == 'root'" class="dropdown-item" style="cursor: pointer;"
            [routerLink]="['/root', 'users' , user.id, 'credit-history']" translate>Credit History</a>
          <a *ngIf="this.currentUser.role.name != 'manager'" class="dropdown-item" style="cursor: pointer;"
            (click)="onEdit(user)" translate>user.editUser</a>
          <a *ngIf="!(this.currentUser.role.name == 'manager' || router.url == '/root/users')" class="dropdown-item"
            style="cursor: pointer;" (click)="showDialogDeleteUser()" translate>user.deleteUser</a>
          <a *ngIf="this.currentUser.role.name == 'root'" class="dropdown-item" style="cursor: pointer;"
            (click)="onMetadata(user.id)" translate>Metadata</a>
          <a *ngIf="this.currentUser.role.name == 'root'" class="dropdown-item" style="cursor: pointer;"
            (click)="toggleDeleteNotifications = true" translate>Delete User Notifications</a>
          <a *ngIf="!(this.currentUser.role.name == 'client' || this.currentUser.role.name == 'manager') "
            class="dropdown-item" style="cursor: pointer;" (click)="showDialogChangeUserApplication(user)"
            translate>customer.changeClient</a>
        </div>
      </div>
    </div>
    <h3 class="widget-user-username">{{user.name}}</h3>
    <h6 class="widget-user-desc">{{user.email}}</h6>
    <div class="row position-right">
      <div class="online">
        <div class="circle" [ngStyle]="{'background-color': user.onlineColor}">
        </div>{{user.online}}
      </div>
    </div>
  </div>
  <div class="widget-user-image">
    <div class="img-circle elevation-2 profile-picture"
      [style.background-image]="user.profilePicture ? 'url(' + user.profilePicture.path + ')' : 'url(assets/img/catcher.png)'">
    </div>
  </div>
  <div class="card-footer bg-card-footer">
    <div *ngIf="router.url === '/root/users' && user.role.name !== 'customer'" class="card-info1">
      <div class="desc-left">
        <p>Client:</p>
      </div>
      <div class="desc-right">
        <p>{{user.client?.name | titlecase}}</p>
      </div>
    </div>

    <div *ngIf="router.url === '/root/users'" class="card-info1">
      <div class="desc-left">
        <p>Customer:</p>
      </div>
      <div class="desc-right">
        <p>{{user.customer?.name | titlecase}}</p>
      </div>
    </div>

    <div *ngIf="user.role.name === 'user'" class="card-info1">
      <div class="desc-left">
        <p translate>user.type<span>:</span></p>
      </div>
      <div class="desc-right">
        <p translate>{{ user.role?.type === 'basic' ? 'user.typeBasic' : (user.role?.type | titlecase) }}</p>
      </div>
    </div>

    <div *ngIf="user.role.name === 'user'" class="card-info1">
      <div class="desc-left">
        <p translate>user.qc</p>
      </div>
      <div class="desc-right">
        <p translate>{{ user.qcEnabled ? 'user.enabled' : 'user.disabled' }}</p>
      </div>
    </div>

    <div class="card-info1" *ngIf="user.role.name !== 'customer'">
      <div class="desc-left">
        <p>Credit:</p>
      </div>
      <div class="desc-right">
        <p>{{user.client?.credits ? user.client.credits : 0}}</p>
      </div>
      <!-- <span *ngIf="user.useCreditsFrom === 'client'" class="small">(client credit)</span> -->
    </div>

    <div class="card-info1" *ngIf="user.role.name !== 'customer'">
      <div class="desc-left">
        <p>Premium Credits:</p>
      </div>
      <div class="desc-right">
        <p>{{user.client?.premiumCredits ? user.client.premiumCredits : 0}}</p>
      </div>
      <!-- <span *ngIf="user.useCreditsFrom === 'client'" class="small">(client credit)</span> -->
    </div>

    <div class="card-info1" *ngIf="user.createdOn">
      <div class="desc-left">
        <p>Created on:</p>
      </div>
      <div class="desc-right">
        <p>{{user.createdOn}}</p>
      </div>
    </div>

    <div class="card-info1"
      *ngIf="['root', 'customer'].includes(currentUser.role.name) && user.role?.type != 'simple' && user.role?.name === 'user'">
      <div class="customer-text">Tokens:</div>
      <div class="link-button-root" (click)="showDialogChangeExteriorMax(user)">
        &nbsp; <i class="fa fa-pencil-square center mr-2" aria-hidden="true"></i> {{user.maxCount}}</div>
    </div>

    <div class="card-info1" *ngIf="user.additionalInvoiceInfo">
      <div class="desc-left mt-auto mb-auto p-0 col-6">
        <p>Additional Invoice Info:</p>
      </div>
      <div class="desc-right text-right col-6">
        <p>{{user.additionalInvoiceInfo}}</p>
      </div>
    </div>

    <div class="card-info1" *ngIf="user.role.name === 'user'">
      <button *ngIf="user.role.type !== 'simple'" class="custom-button" (click)="seeVehicles(user.id)"translate>user.seeVehicles</button>
      <button *ngIf="user.role.type === 'simple'" class="custom-button" (click)="seeCrops(user.id)" translate>user.seeCrops</button>
      <button *ngIf="currentUser.role.name === 'root'" class="custom-button" (click)="loginUser(user.id)">Login As
        User</button>
    </div>
  </div>
</div>

<app-modal (close)="toggleEditUser = !toggleEditUser" *ngIf="toggleEditUser">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>user.editUser</p>

    <form #userForm="ngForm" class="form-vehicle">

      <!-- Name -->
      <div class="form-group">
        <label translate>customer.fullName</label>
        <input type="text" name="name" autocomplete="off" required [ngModel]="selectedUser.name" class="form-control">
      </div>

      <!-- Email -->
      <div class="form-group">
        <label>Email</label>
        <input type="text" name="email" autocomplete="off" required [ngModel]="selectedUser.email" class="form-control">
      </div>

       <!-- additionalInvoiceInfo -->
       <div class="form-group">
        <label translate>user.additionalInvInfo</label>
        <textarea  type="text" #additionalInvoiceInfo="ngModel" autocomplete="off" [ngModel]="selectedUser.additionalInvoiceInfo" ngModel class="form-control"
          [class.is-invalid]="additionalInvoiceInfo.invalid && additionalInvoiceInfo.touched" name="additionalInvoiceInfo" rows="2"></textarea>
      </div>


      <!-- Type -->
      <!-- <div class="form-group">
        <label translate>Type</label>
        <select class="form-control" name="type" name="type" [ngModel]="selectedUser.role.type">
          <option value="basic">Basic</option>
          <option value="simple">Simple</option>
        </select>
      </div> -->

      <button type="submit" class="custom-button" (click)="editUser(userForm)" style="width: 120px;"
        translate>global.save</button>

    </form>
  </div>
</app-modal>

<app-modal (close)="toggleMetadata = !toggleMetadata" *ngIf="toggleMetadata">
  <div class="modal_container black-text" style="font-size: .9rem;">
    <p class="text-header-modal" translate>Metadata</p>

    <div style="height: 500px; overflow: auto;">
      <div class="py-3" *ngFor="let device of userDevices">
        <label class="w-100" style="font-weight: bold;">Created: <span>{{device.createdAt | date:'dd.MM.yyyy HH:mm'}}</span></label>
        <label class="w-100">OS: <span>{{device?.meta?.os}}</span></label>
        <label class="w-100">Model: <span>{{device?.meta?.model}}</span></label>
        <label class="w-100">App Version: <span>{{device?.meta?.appVersion}}</span></label>
        <label class="w-100">Manufacturer: <span>{{device?.meta?.manufacturer}}</span></label>
      </div>
    </div>
  </div>
</app-modal>

<!--Delete user-->
<ng-template #dialogDeleteUser let-c="close" let-d="dismiss">
  <div class="modal-body">
    <div class="row">
      <p translate>customer.deleteUserMessage</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteRequest(user)"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<!-- Modal Form CHANGE User Application -->
<ng-template #dialogChangeUserApplication let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>user.changeClient</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="form-vehicle">
      <div #searchContainer [ngClass]="{'active' : showClients}" class="div select-bg search-container w-100"
        style="display: block; position: relative;">
        <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
          (click)="openCustomers()" name="selectedPreset"
          [attr.placeholder]="selectedClient ? selectedClient.name : ('customer.selectApp' | translate)">

        <div class="form-group">
          <div class="prikaz" *ngIf="showClients">
            <div class="backdrop" (click)="openCustomers()"></div>
            <div style="z-index: 100; overflow-y: auto;">
              <div class="divider"></div>
              <input type="text" class="search-marke" (input)="applyCustomerFilter()"
                [attr.placeholder]="'user.search' | translate" name="searchCustomersParam" name="searchCustomersParam"
                [(ngModel)]="searchCustomersParam">
              <ul style="margin-bottom: 12px;">
                <li *ngFor="let client of filteredClients"
                  (click)="showClients = !showClients; selectClient(client)">
                  {{ client.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid d-flex flex-column flex-sm-row justify-content-end" style="gap: 0.5rem">  
        <button style="min-width: 150px;" (click)="onCloseChangeClient()" class="custom-button mt-3" translate>global.cancel</button>
        <button style="min-width: 150px;" (click)="sendChangeUserApplication()" class="custom-button mt-3" translate>global.change</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Modal Form CHANGE User Exterior Calls Limit -->
<ng-template #dialogChangeExteriorMax let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>user.changeMaxExteriorAPICalls</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #userExteriorMaxForm="ngForm" (ngSubmit)="sendUserMaxExterior(userExteriorMaxForm)" class="form-vehicle">
      <!-- Credit -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>user.newLimit</span>
          </div>
          <input type="number" class="form-control" id="exteriorMax" name="exteriorMax" ngModel required>
          <button type="submit" class="btn btn-success" [disabled]="!userExteriorMaxForm.form.valid" translate>global.save</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-modal id="add-webhook" *ngIf="toggleDeleteNotifications" (close)="toggleDeleteNotifications = false">
  <div class="modal_container" style="text-align: initial; letter-spacing: 1px; font-weight: 100 !important; color: #15171a;">
    <div class="p-4">
      <p>Are you sure you want to delete all user notifications?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteUserNotifications()"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleDeleteNotifications = false" translate>global.no</button>
  </div>
</app-modal>